module.exports = __webpack_public_path__ + "static/media/item__food-1.ee62a301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-1.png
// module id = 2326
// module chunks = 0